import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
  row: ({ lineThrough }: { lineThrough: boolean }) => ({
    textDecoration: lineThrough ? "line-through" : "none",
  })
});

export default useStyles;
